import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { LanguageService } from 'app/services/language.service';

@Injectable()
export class LanguageHeaderInterceptor implements HttpInterceptor {
  private languageService: LanguageService = inject(LanguageService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentLanguage: string = this.languageService?.currentLanguage?.languageKey;

    if (currentLanguage != null) {
      request = request.clone({
        setHeaders: {
          'SMRTNC-LANGUAGE': currentLanguage
        }
      });
    }

    return next.handle(request);
  }
}
